/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-lab-item-enum.reducer';

export const UserLabItemEnumDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userLabItemEnumEntity = useAppSelector(state => state.userLabItemEnum.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userLabItemEnumDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.userLabItemEnum.detail.title">UserLabItemEnum</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.userLabItemEnum.id">Id</Translate>
            </span>
          </dt>
          <dd>{userLabItemEnumEntity.id}</dd>
          <dt>
            <span id="entityId">
              <Translate contentKey="tinyMedicRestApp.userLabItemEnum.entityId">Entity Id</Translate>
            </span>
          </dt>
          <dd>{userLabItemEnumEntity.entityId}</dd>
          <dt>
            <span id="labItemId">
              <Translate contentKey="tinyMedicRestApp.userLabItemEnum.labItemId">Lab Item Id</Translate>
            </span>
          </dt>
          <dd>{userLabItemEnumEntity.labItemId}</dd>
          <dt>
            <span id="entityName">
              <Translate contentKey="tinyMedicRestApp.userLabItemEnum.entityName">Entity Name</Translate>
            </span>
          </dt>
          <dd>{userLabItemEnumEntity.entityName}</dd>
        </dl>
        <Button tag={Link} to="/user-lab-item-enum" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-lab-item-enum/${userLabItemEnumEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserLabItemEnumDetail;
